import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { AuthLayout } from '../components/AuthLayout';
import { verifyEmail } from '../repositories/readerRepository';

/**
 * Where a confirmation email lands (app/services/frontend_links.py). The token
 * is spent only on a click: mail scanners follow links, and one that confirmed
 * on load would prove nothing about who reads the mailbox (PRO-701).
 */
export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [message, setMessage] = useState(token ? '' : 'This confirmation link is missing its token.');
  const [isError, setIsError] = useState(!token);
  const [confirmed, setConfirmed] = useState(false);
  const [busy, setBusy] = useState(false);

  const confirm = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setBusy(true);
    setMessage('');
    try {
      await verifyEmail(token);
      setConfirmed(true);
      setIsError(false);
      setMessage('Your email address is confirmed.');
    } catch (err) {
      setIsError(true);
      setMessage((err as Error).message || 'This confirmation link is invalid or has expired.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout
      title="Confirm your email"
      subtitle="Confirm this address to receive TLDR For You by email."
      message={message}
      isError={isError}
      footer={<Link to="/digests">Email settings</Link>}
    >
      {!confirmed && (
        <form onSubmit={confirm} className="auth-form">
          <button type="submit" className="primary-button" disabled={!token || busy}>
            {busy ? 'Confirming…' : 'Confirm email address'}
          </button>
        </form>
      )}
    </AuthLayout>
  );
}
